import styled from '@xstyled/styled-components';

import Icon from '../../Icon/Icon';

export const StyledIcon = styled(Icon)`
  margin: 0 0 0 0.5rem;
  min-width: 16px;
`;
